import { connect } from 'react-redux';
import { compose } from 'recompose';

import { components as clientComponents } from 'mage-client';
import { withPolling } from 'moet-core';

import { logEvent } from '@/utils/analytics';
import {
  getMerchantStatus,
  getProductsFromPreAssessmentDetails,
  preAssessmentDetails,
  preAssessmentUnderwritingStatus,
  merchantRegion,
} from '@/selectors/merchant';
import { getMerchantAwareTranslator } from '@/selectors/merchant/common';
import { isFetchingPreAssessmentStatus } from '@/selectors/loadingStates';
import { CAPS, PRE_ASSESSMENT_STATUSES } from '@/constants';
import { withCapabilityBeforeNext } from '@/flow/common';
import { PreAssessmentOverview } from './PreAssessmentOverview';
import { ANALYTICS_EVENTS } from './analyticsEvents';
import { POLLING_INTERVAL } from './constants';

export default compose(
  connect(
    state => ({
      tMerchantAware: getMerchantAwareTranslator(state),
      isFetchingPreAssessmentStatus: isFetchingPreAssessmentStatus(state),
      merchantRegion: merchantRegion(state),
      merchantStatus: getMerchantStatus(state),
      preAssessment: preAssessmentDetails(state),
      selectedProducts: getProductsFromPreAssessmentDetails(state),
      underwritingStatus: preAssessmentUnderwritingStatus(state),
    }),
    {},
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      goToStep: path => {
        ownProps.history.push(`${ownProps.basePath}/${path}` + ownProps.history.location.search);
      },
    }),
  ),
  withCapabilityBeforeNext({ edit: CAPS.V2_PRE_ASSESSMENT_PATCH }, () =>
    logEvent(ANALYTICS_EVENTS.preAssessmentNewCase),
  ),
  clientComponents.withCapabilities({
    getUnderwritingStatus: CAPS.V2_PRE_ASSESSMENT_UNDERWRITING_STATUS_GET,
  }),
  withPolling(
    ({ getUnderwritingStatus, mid, merchantRegion }) =>
      getUnderwritingStatus({ params: { mid }, region: merchantRegion }),
    (
      { isFetchingPreAssessmentStatus: wasFetchingPreAssessmentStatus },
      { isFetchingPreAssessmentStatus },
    ) => wasFetchingPreAssessmentStatus && !isFetchingPreAssessmentStatus,
    {
      intervalCriteria: () => POLLING_INTERVAL,
      exitCriteria: (prevProps, { underwritingStatus }) =>
        [PRE_ASSESSMENT_STATUSES.APPROVED, PRE_ASSESSMENT_STATUSES.REJECTED].includes(
          underwritingStatus,
        ),
      maxDelayTime: POLLING_INTERVAL,
    },
  ),
)(PreAssessmentOverview);
